import React, { useEffect, useState } from "react";
import "./styles.scss";
import listRecommend from "../../services/list-recommend";
import Carousel from 'react-multi-carousel';
import stringJp from '../../constants/stringJP';
import { Button, Modal, message, Typography } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined, DeleteFilled } from '@ant-design/icons';
import chartService from '../../services/chart-sevices'
import { RadarChart } from "../../components/charts/radarChart.js";
import 'react-multi-carousel/lib/styles.css';

export default function Additional(props) {
    const {
        dataChart, account_id,
        company_code, store_code,
        instore_code, security_key,
        area_code, timerange_code,
        cart_flag, add_flag
    } = props;

    const [product, setProduct] = useState([]);
    const [dataListCart, setDataListCart] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [dataChartAddCart, setDataChartAddCart] = useState([]);
    const [itemCode, setItemCode] = useState(false);
    const { Paragraph } = Typography;
    // const regex = /[^（(＜<〈]*/;
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 3
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 375 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 375, min: 0 },
            items: 3
        },
    };

    useEffect(() => {

        const paramsGetPrd = {
            account_id: account_id,
            company_code: company_code,
            store_code: store_code,
            instore_code: instore_code,
            security_key: security_key
        };

        chartService.getPrdInCart(paramsGetPrd, (res) => {
            if (res.result && res.result === 'success') {
                if (res.data && res.data.length > 0) {
                    setDataListCart(res.data[0]?.item_cart_list)
                }
            }
        })
        return () => { // This code runs when component is unmounted
            setDataListCart([]);
        }
    }, [account_id]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const params = {
            account_id: account_id,
            company_code: company_code,
            security_key: security_key,
            store_code: store_code,
            instore_code: instore_code,
            area_code: area_code,
            timerange_code: timerange_code,
            data_chart: dataChart
        };
        listRecommend.postRecommend(
            params,
            (res) => {
                if (res.data) {
                    const dataNew = Object?.entries(res.data)?.slice(0, 3).map((item, index) => {
                        const newItem = item[1][0]?.item_list?.map((itemList, index1) => {
                            return {
                                ...itemList,
                                count: 0
                            }
                        });
                        return {
                            title: item[0],
                            dataPrd: newItem ? newItem : []
                        }
                    })
                    setProduct(dataNew ? dataNew : [])
                }
            },
            () => { }
        );

        return () => { // This code runs when component is unmounted
            setProduct([]);
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const paramsGetChart = {
            account_id: account_id,
            company_code: company_code,
            store_code: store_code,
            instore_code: instore_code,
            security_key: security_key
        }

        chartService.getRadarAddToCard(paramsGetChart, (res) => {
            if (res.result && res.result === 'success') {
                if (res.data && res.data?.data_chart) {
                    setDataChartAddCart(res.data.data_chart)
                }
            }
        })

        return () => { // This code runs when component is unmounted
            setDataChartAddCart([]);
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {

        if (cart_flag === 'true') {
            setModalVisible(true);
        }

        if (cart_flag === 'false') {
            setModalVisible(false);
        }
    }, [cart_flag])

    const titleList = (dataTitle, index) => {
        switch (index) {
            case 0:
                return <h3 className="text_title_style">不足している{dataTitle}に</h3>
            case 1:
                return <h3 className="text_title_style">{dataTitle}をとるには</h3>
            case 2:
                return <h3 className="text_title_style">{dataTitle}が豊富な食品はこちら</h3>
            default:
                break;
        }
    };

    const recommendList = (dataRecommend, index) => {

        if (!dataRecommend?.dataPrd?.length) return;

        const dataRecommends = dataRecommend?.dataPrd.map((item, index) => {

            item.item_quantity = "";

            for (const item2 of dataListCart) {
                if (item2.item_code === item.item_code) {
                    item.item_quantity = item2.item_quantity;
                    item.cart_flag = item2.cart_flag;
                }
            }
            return { ...item }
        })

        const recommendRender = (item, index) => {

            const popupRender = (data) => {

                if (data.item_quantity === "0" || !data.item_quantity) {
                    setItemCode(false);
                };

                const handleAddToCart = (evt, check) => {
                    evt.stopPropagation();
                    const params = {
                        account_id: account_id,
                        company_code: company_code,
                        store_code: store_code,
                        scancode: data.item_code,
                        quantity: (Number(data.item_quantity ? data.item_quantity : '0') + (check === 'add' ? 1 : (-1))).toString()
                    }

                    chartService.addToCart(params, (res) => {
                        if (res.result && res.result === 'success') {
                            setDataListCart(res.data[0]?.cart_list[0]?.items);
                            // setModalVisibleConfirm(true);
                        }

                        if (res.data) {
                            if (res.data.result === 'failure' && res.data.errors) {
                                const dataErr = res.data.errors

                                message.error({
                                    content: dataErr.length > 55 ? (dataErr.substring(0, dataErr.length - 3).slice(51)) : "例外エラーが発生しました",
                                    className: 'custom-class'
                                });
                                // setModalVisibleConfirm(false);
                            }
                        }
                    });
                }

                return (
                    <div className="btn_popup">
                        <div className="body_tooltip_container">
                            <Button
                                type="text"
                                size="large"
                                shape="circle"
                                icon={data.item_quantity === "1" ?
                                    <DeleteFilled style={{ fontSize: 20, color: "#09D3B7" }} /> :
                                    <MinusCircleOutlined style={{ fontSize: 20, color: (data.item_quantity === "0" || !data.item_quantity) ? "##C4C4C4" : "#09D3B7" }} />
                                }
                                disabled={data.item_quantity === "0" || !data.item_quantity}
                                onClick={(evt) => handleAddToCart(evt, "minus")}
                            />
                            <h6 className="text_tooltip">{data.item_quantity}</h6>
                            <Button
                                type="text"
                                size="large"
                                shape="circle"
                                icon={
                                    <PlusCircleOutlined
                                        style={{ fontSize: 20, color: "#09D3B7" }}
                                    />
                                }
                                onClick={(evt) => handleAddToCart(evt, "add")}
                            />
                        </div>
                    </div>
                )
            };

            const buttonAdd = (dataTotal) => {

                const handleClickBtnAdd = (evt, data) => {

                    evt.stopPropagation();

                    if (!data.item_quantity) {

                        setItemCode(false);

                        const params = {
                            account_id: account_id,
                            company_code: company_code,
                            store_code: store_code,
                            scancode: data.item_code,
                            quantity: (Number(data.item_quantity ? data.item_quantity : '0') + 1).toString()
                        }

                        chartService.addToCart(params, (res) => {
                            if (res.result && res.result === 'success') {
                                setDataListCart(res.data[0]?.cart_list[0]?.items);
                                setItemCode(data.item_code);
                                // setModalVisibleConfirm(true);
                            }

                            if (res.data) {
                                if (res.data.result === 'failure' && res.data.errors) {
                                    const dataErr = res.data.errors

                                    message.error({
                                        content: dataErr.length > 55 ? (dataErr.substring(0, dataErr.length - 3).slice(51)) : "例外エラーが発生しました",
                                        className: 'custom-class'
                                    });
                                    // setModalVisibleConfirm(false)
                                }
                            }
                        });
                    }

                    if (data.item_quantity) {
                        setItemCode(data.item_code);
                    }
                }

                return (
                    <div
                        id="button-add"
                        onClick={(event) => handleClickBtnAdd(event, dataTotal)}
                        className="prd_count">
                        <h3 style={{ fontSize: 12, color: "#09D3B7", marginTop: 2 }}>
                            {dataTotal.item_quantity ? dataTotal.item_quantity : "+"}
                        </h3>
                    </div>
                )
            };

            return (
                <div key={index.toString()} >
                    {item.item_name === null ? "" :
                        <div className="style_body_items" >
                            <div style={{ width: 95, padding: 2, paddingTop: 0 }}>
                                {add_flag !== 'true' ? null
                                    : item.item_code === itemCode ? popupRender(item)
                                        : buttonAdd(item)
                                }
                                <img
                                    style={{ width: 80, height: 80, backgroundColor: 'transparent', marginTop: 30 }}
                                    src={item.image_url} alt="" />
                            </div>

                            <Paragraph
                                ellipsis={{ rows: 2 }}
                                className="text_products"
                                // ellipsis={true}
                            // style={{ marginLeft: -10}}
                            > {item.item_name ? item.item_name : ''} </Paragraph>

                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ position: 'absolute', bottom: 5, left: 5 }}>
                                    <p className="text_standard">{item.standard}</p>
                                </div>
                                <div className="name_price"
                                    style={{ position: 'absolute', bottom: -10, right: 5 }}>
                                    ¥{item.price}
                                    <br />
                                    <p className="tax_included_notation">{item.tax_included_notation}</p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            )
        }

        return (
            <div className="add" key={index.toString()}>
                {titleList(dataRecommend?.title, index)}
                <div className="products" >
                    <Carousel responsive={responsive} >
                        {dataRecommends.map((item, index) => recommendRender(item, index))}
                    </Carousel>
                </div>
            </div>
        )
    };

    return (
        <div
            id="list-item"
            onClick={(evt) => {
                if (evt.currentTarget.id === 'list-item') {
                    setItemCode(false);
                }
            }}>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                <h3 className="title_recommends"> {
                    (!product[0]?.dataPrd?.length
                        && !product[1]?.dataPrd?.length
                        && !product[2]?.dataPrd?.length)
                        ? '' : stringJp.label_title_recommend}
                </h3>
            </div>

            <div style={{ padding: '0px 17px 10px 17px' }}>
                {product.length > 0 ?
                    product.map((item, index) => recommendList(item, index)) : null}
            </div>

            <Modal
                title="カート内の栄養価"
                centered
                visible={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                footer={null}>
                <div style={{ padding: '0px 17px 10px 17px' }}>
                    <RadarChart dataChart={dataChartAddCart} />
                </div>
            </Modal>
        </div>
    );
}